import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import IcAlert from '../../../assets/images/svg/ic_alert.svg';
import { color } from '../../../app/theme';
import config from '../../../app/config';
import { checkPlatform } from '../../../features/mainSlice';

const useStyles = makeStyles(
  {
    tip: {
      display: 'flex',
      alignItems: 'start',
      padding: '13px 16px',
      background: 'rgba(241, 192, 54, 0.10)',
      borderRadius: 4,
      marginBottom: 12,
      '& > img': {
        marginRight: 12,
      },
      '& a': {
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '21px',
        color: color.$18,
        textDecoration: 'underline',
      },
      '& > div, a': {
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '21px',
        color: color.$18,
      },
    },
  },
  {
    name: 'PlatformTip',
  },
);

const PlatformTip = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { objectId, integration } = useSelector(store => store.organization);
  const { data } = useSelector(store => store.ma);
  const { platform } = data || {};

  const isPlatformVerify = checkPlatform(platform, integration);

  if (isPlatformVerify) {
    return null;
  }

  return (
    <div>
      <div className={classes.tip}>
        <img src={IcAlert} alt="alert" />
        <div>
          <div style={{ fontWeight: '500' }}>{t('platformTipTitle')}</div>
          {t('platformTipContent', {
            platform: platform ? t(platform) : '',
          })}
          <a
            href={`${config.CONSOLE_URL}/organization-setting/${objectId}/linked-app`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('platformTipUrl')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PlatformTip;
